<template>
    <div>
        <v-card>
            <v-card-title class="teal" dark>UPLOAD FILE JADWAL</v-card-title>
            <v-card-subtitle class="teal" dark>{{ paketKode }} - {{ paketNama }}</v-card-subtitle>

                <v-data-table :items="listJadwal" :headers="headers" hide-default-footer :items-per-page="-1">
                    <!-- File Jadwal -->
                    <template v-slot:item.fileJadwal="{item}">
                        <v-file-input
                            :placeholder="item.fileJadwal" 
                            accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" 
                            @change="setUploadFile($event, item)"
                        >
                            <template v-if="item.fileJadwal !== ''" v-slot:append>
                                <v-btn icon @click="tenderLib.getFileDownloadLink(paketId, `FileJadwal_${item.urut}`, item.fileJadwal, false)"><v-icon color="green">get_app</v-icon></v-btn>
                            </template>
                        </v-file-input>
                    </template>

                    <!-- Show Vendor -->
                    <template v-slot:item.showVendor="{item}">
                        <v-simple-checkbox v-model="item.showVendor" />
                    </template>
                </v-data-table>
            
            <v-divider />

            <v-card-actions>
                <v-btn color="cyan" dark @click="close()">Tutup</v-btn>
                <v-btn color="green" dark @click="submit()">Simpan</v-btn>
            </v-card-actions>

        </v-card>

        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :timeout=3000
            top
        >
            {{ notification.text }}
        </v-snackbar>
        
        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>


<script>

const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { TenderLib } from "./../../lib/tenderLib";


export default {
    props: {
        paketId: {
            type: Number,
            required: true
        },
        paketKode: {
            type: String,
            default: ""
        },
        paketNama: {
            type: String,
            default: ""
        },
    },

    data() {
        return {
            tenderLib: TenderLib,

            headers: [
                { text: "No.", value: "urut", class: "subtitle-2 font-weight-bold", sortable: false, width: "2%" }, 
                { text: "Tahap", value: "tahap", class: "subtitle-2 font-weight-bold", sortable: false },
                { text: "File", value: "fileJadwal", class: "subtitle-2 font-weight-bold", sortable: false, width: "40%" },
                { text: "Akses Vendor", value: "showVendor", class: "subtitle-2 font-weight-bold", sortable: false, width: "5%" },
            ], 

            listJadwal: [], 
            listUploadFile: [],

            notification: {
                show: false,
                color: "success",
                text: ""
            },

            submitting: false,
        }
    },


    watch: {
        paketId() {
            this.getData();
        }
    },


    mounted() {
        this.getData();
    },

    methods: {
        getData() {
            this.listJadwal = [];
            this.listUploadFile = [];

            axios.get(`${apiUrl}/api/rup/jadwal/${this.paketId}`)
            .then( (response) => {
                this.listJadwal = response.data;
                this.listUploadFile.length = this.listJadwal.length;

            }).catch( (error) => {
                console.error(error);
            });
        },

        setUploadFile(value, jadwal) {
            const index = this.listJadwal.findIndex(check => check.urut === jadwal.urut);

            if (index != -1) {
                this.listUploadFile[index] = value;
            }
            else {
                this.notification = {
                    show: true,
                    color: "error",
                    text: "INVALIDDD"
                }
            }
        },

        close() {
            this.$emit("closed");
        },

        submit() {
            let fileCount = 0;
            for (let i = 0; i < this.listUploadFile.length; ++i) {
                if (this.listUploadFile[i] && this.listUploadFile[i] != null && this.listUploadFile[i] !== "undefined") {
                    fileCount++;
                }
            }

            if (fileCount === 0) {
                this.notification = {
                    show: true,
                    color: "error",
                    text: "Masukkan minimal 1 (satu) file sebelum upload"
                };

                return;
            }

            let fdata = new FormData();
            fdata.append("paketPenyediaId", this.paketId);
            fdata.append("fileCount", this.listUploadFile.length);

            for (let i = 0; i < this.listUploadFile.length; ++i) {
                fdata.append(`uploadFiles[${i}]`, this.listUploadFile[i]);
                fdata.append(`showVendors[${i}]`, this.listJadwal[i].showVendor);
            }

            this.submitting = true;

            axios.post(`${apiUrl}/api/rup/jadwal/upload`, fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then( (response) => {
                this.listJadwal = response.data;
                this.listUploadFile = [];
                this.listUploadFile.length = this.listJadwal.length;

                this.notification = {
                    show: true,
                    color: "success",
                    text: "File jadwal berhasil di-upload"
                };

                this.$emit("submitted", true);

            }).catch( (error) => {
                console.error(error);

                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal upload file jadwal [${error.message}]`
                };

                this.$emit("submitted", false);

            }).finally( () => {
                this.submitting = false;
            });
        },

    }, // methods
}

</script>
